import { Seo } from "../components/Seo";
import { LegalLayout } from "../components/LegalLayout";

const sections = [
  {
    title: "Acceptance of these terms",
    body: "By accessing the Chatbudds website or engaging our services, you agree to these Terms of Service. If you do not agree, please do not use our website or services. For client engagements, a signed proposal or service agreement may supplement these terms; where the two conflict, the signed agreement prevails.",
  },
  {
    title: "Our services",
    body: "Chatbudds is a performance marketing agency. Our services include the planning, management and optimisation of paid advertising campaigns on Meta (Facebook and Instagram) and Google (Search, Display, YouTube and Performance Max), along with related creative direction, tracking setup and reporting. The exact scope, deliverables and timelines for your engagement are defined in your individual proposal or service agreement.",
  },
  {
    title: "Client responsibilities",
    points: [
      "Provide accurate business information and timely access to ad accounts, assets and approvals needed to run your campaigns.",
      "Ensure your products, services and ad content comply with the advertising policies of Meta and Google, and with all applicable laws.",
      "Maintain valid payment methods with the ad platforms, as advertising spend is billed to you directly by them.",
      "Review and approve campaign creatives, copy and landing pages before or shortly after launch.",
    ],
    body: "To deliver results, we rely on your cooperation. As our client, you agree to:",
  },
  {
    title: "Fees and payment",
    body: "Our management fees are set out in your proposal or invoice and are payable as stated there. Advertising spend is separate from our fees — it is either billed to you directly by the ad platforms or paid to us for onward credit to your ad account, as agreed in your proposal. Work may be paused if invoices remain unpaid past their due date. Taxes, where applicable, are charged in addition to quoted fees.",
  },
  {
    title: "No guaranteed results",
    body: "We commit to honest strategy, best-practice execution and transparent reporting. However, advertising performance depends on many factors outside our control — your market, offer, pricing, website and budget among them. Unless explicitly agreed in writing, we do not guarantee specific numbers of leads, sales or returns.",
  },
  {
    title: "Intellectual property",
    body: "You retain ownership of your brand assets and materials you provide to us. On full payment, you own the final deliverables we create specifically for you (such as ad creatives and copy). We retain ownership of our pre-existing tools, templates, processes and know-how used to deliver the work.",
  },
  {
    title: "Confidentiality",
    body: "Both parties agree to keep non-public business information shared during the engagement confidential, and to use it only for the purpose of delivering or receiving the services.",
  },
  {
    title: "Limitation of liability",
    body: "To the maximum extent permitted by law, Chatbudds is not liable for any indirect or consequential losses (including lost profits). Our total liability for any claim arising from our services is limited to the management fees you paid us in the three months preceding the claim.",
  },
  {
    title: "Termination",
    body: "Either party may end an engagement as described in the service agreement. Our Cancellation & Refund Policy explains how cancellations and refunds are handled.",
  },
  {
    title: "Governing law",
    body: "These terms are governed by the laws of India. Any disputes will be subject to the jurisdiction of the courts at Ghaziabad, Uttar Pradesh.",
  },
  {
    title: "Changes to these terms",
    body: "We may update these terms from time to time. The date at the top of this page shows when they were last revised. Continued use of our website or services after an update means you accept the revised terms.",
  },
  {
    title: "Contact us",
    body: "Questions about these terms? Reach us at chatbudds2@gmail.com, call or WhatsApp +91 84484 44896, or write to Chatbudds, 747, Niti Khand -1, Indirapuram, Ghaziabad.",
  },
];

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms of Service — Chatbudds"
        description="The terms that govern use of the Chatbudds website and our performance marketing services, including fees, responsibilities and liability."
      />
      <LegalLayout title="Terms of Service" updated="October 2026" sections={sections} testid="terms-page" />
    </>
  );
}
